module.exports = __webpack_public_path__ + "img/twitter-white.d59bd3a7.svg";